import { channels } from "@/data/social";

const WhatsappTelegramChannel = ({ language = "ml" }: { language?: "ml" | "en" }) => {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      <a
        href={channels[language].whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Join our whatsapp channel"
      >
        <div className="flex flex-row gap-2 bg-[#40AC65] dark:bg-[#2d7a48] p-5 rounded-xl shadow-sm h-full">
          <div className="w-[70%]">
            <span className="block text-base sm:text-[17px] font-semibold text-white font-notosans">
              {language === "ml"
                ? "ദേശാഭിമാനി വാർത്തകൾ ഇപ്പോള്‍ വാട്സാപ്പിലും ലഭ്യമാണ്‌"
                : "Deshabhimani articles are available on WhatsApp"}
            </span>
            <span className="block mt-2 sm:mt-3 text-[13px] sm:text-sm font-medium text-white font-notosans">
              {language === "ml"
                ? "വാട്സാപ്പ് ചാനൽ സബ്സ്ക്രൈബ് ചെയ്യുന്നതിന് ക്ലിക് ചെയ്യു..."
                : "Click here to subscribe to our WhatsApp channel"}
            </span>
          </div>
          <div className="relative w-[30%] flex items-center justify-center">
            <img
              src="/images/whatsapp.webp"
              alt="whatsapp"
              className="object-contain max-w-[130px] filter drop-shadow-[-5px_10px_5px_rgba(0,0,0,0.3)]"
              loading="lazy"
            />
          </div>
        </div>
      </a>
      {language === "ml" ? (
        <a
          href={channels[language].instagram}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Join our telegram channel"
        >
          <div className="flex flex-row gap-2 bg-[#e2148f] dark:bg-[#e2148f] p-5 rounded-xl shadow-sm h-full">
            <div className="w-[70%]">
              <span className="block text-base sm:text-[17px] font-semibold text-white font-notosans">
                {language === "ml"
                  ? "ദേശാഭിമാനി വാർത്തകൾ ഇപ്പോള്‍ ഇൻസ്റ്റാഗ്രാമിൽ ലഭ്യമാണ്‌"
                  : "Deshabhimani articles are available on Instagram"}
              </span>
              <span className="block mt-2 sm:mt-3 text-[13px] font-medium text-white sm:text-sm font-notosans">
                {language === "ml"
                  ? "ഇൻസ്റ്റാഗ്രാം പേജ് പിന്തുടരുന്നതിനു ക്ലിക് ചെയ്യു..."
                  : "Click here to follow our Instagram page"}
              </span>
            </div>
            <div className="w-[30%] flex items-center justify-center ">
              <img
                src="/images/instagram.png"
                alt="telegram"
                className="object-contain max-w-[110px] filter drop-shadow-[-5px_10px_5px_rgba(0,0,0,0.3)]"
                loading="lazy"
              />
            </div>
          </div>
        </a>
      ) : (
        <a
          href={channels[language].telegram}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Join our telegram channel"
        >
          <div className="flex flex-row gap-2 bg-[#72B2E0] dark:bg-[#3c7aa7] p-5 rounded-xl shadow-sm h-full">
            <div className="w-[70%]">
              <span className="block text-base sm:text-[17px] font-semibold text-white font-notosans">
                {language === "en"
                  ? "Deshabhimani articles are available on Telegram"
                  : "ദേശാഭിമാനി വാർത്തകൾ ഇപ്പോള്‍ ടെലെഗ്രാമിൽ ലഭ്യമാണ്‌"}
              </span>
              <span className="block mt-2 sm:mt-3 text-[13px] font-medium text-white sm:text-sm font-notosans">
                {language === "en"
                  ? "Click here to subscribe to our Telegram channel"
                  : "ടെലെഗ്രാം ചാനൽ സബ്സ്ക്രൈബ് ചെയ്യുന്നതിന് ക്ലിക് ചെയ്യു..."}
              </span>
            </div>
            <div className="w-[30%] flex items-center justify-center ">
              <img
                src="/images/telegram.svg"
                alt="telegram"
                className="object-contain max-w-[110px] filter drop-shadow-[-5px_10px_5px_rgba(0,0,0,0.3)]"
                loading="lazy"
              />
            </div>
          </div>
        </a>
      )}
    </div>
  );
};

export default WhatsappTelegramChannel;
